import { render, staticRenderFns } from "./curationPage.vue?vue&type=template&id=2da9559a&scoped=true&"
import script from "./curationPage.vue?vue&type=script&lang=js&"
export * from "./curationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da9559a",
  null
  
)

export default component.exports